import { Box, Text } from "@chakra-ui/react"
import Link from "@pathwright/ux/src/components/link/Link"
import { usePathwrightContext } from "@pathwright/features/src/modules/pathwright/PathwrightContext"
import { PATHWRIGHT_SCHOOL_ID } from "../../lib/core/constants"

function CreateSpacePrompt() {
  const { school } = usePathwrightContext()

  return school.id === PATHWRIGHT_SCHOOL_ID ? (
    <Box
      className="GlobalAuth__create-space-prompt"
      display="none"
      css={{
        // Prevents displaying the prompt unitl the auth flow has rendered.
        [".GlobalAuth__wrapper:has(.AdaptedAuthContainer) &"]: {
          display: "block"
        }
      }}
    >
      <Text textAlign="center">
        Don’t have a Learning Space yet?{" "}
        <Link to="/sign-up/" textDecor="underline">
          Create one
        </Link>
        .
      </Text>
    </Box>
  ) : null
}

export default CreateSpacePrompt
